var _rect, _circle, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#e5e7eb",
    rx: 12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 58,
    r: 28,
    fill: "#9ca3af"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 138,
    rx: 46,
    ry: 34,
    fill: "#9ca3af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/default_photo.a15291179153840087a348d6096683ab.svg";
export { ForwardRef as ReactComponent };